import {
  Alert,
  AppBar,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Snackbar,
  Stack,
  TextField,
  Toolbar,
  Tooltip,
  Typography
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";

import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import HelpIcon from "@mui/icons-material/Help";
import HistoryIcon from "@mui/icons-material/History";
import KeyboardTabIcon from "@mui/icons-material/KeyboardTab";
import UndoIcon from '@mui/icons-material/Undo';
import MuiPagination from "@mui/material/Pagination";
import {
  DataGridPremium,
  GridCsvExportMenuItem,
  GridExcelExportMenuItem,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridToolbarFilterButton,
  gridFilteredSortedRowIdsSelector,
  useGridApiRef, useGridSelector, gridPageCountSelector,
} from "@mui/x-data-grid-premium";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import FieldNames from "../../../../defaults/FieldNames.json";
import GridDefinitions from "../../../../defaults/GridDefinitions.json";
import AuditLogService from "../../../../services/AuditLogService";
import CancelService from "../../../../services/CancelService";
import CarryoverService from "../../../../services/CarryoverService";
import ErrorService from "../../../../services/ErrorService";
import FeatureService from "../../../../services/FeatureService";
import {
  calculateFiscalYearQuarter, formatDateForDisplay,
  getSaveableDate,
  handleBulkCarryoverTargetInitDateChange
} from "../../../../utils/DateHelper";
import { isFeaturePostFire, isFeatureTreatment } from "../../../../utils/FeatureHelper";
import BasicTextField from "../../../details/customPanels/BasicTextField";
import InFormGenericModal from "../../../InFormGenericModal";
import { MuiMenuDropdown } from "../../../MuiMenuDropdown";
import CancelEntryPopup from "./CancelEntryPopup";
import CarryoverEntryPopup from "./CarryoverEntryPopup";
import WorkflowFiscalYearFilter from "./WorkflowFiscalYearFilter";
import WorkflowGridFilters from "./WorkflowGridFilters";
import UndoCarryoverPopup from "./UndoCarryoverPopup";
import {useGridApiContext} from "@mui/x-data-grid";

export default function CarryoverManagementDialog({
  currentUserInfo,
  userRoleInfo,
  setShowMap,
  headerheight
}) {
  const navigate = useNavigate();
  const config = useSelector((state) => state.configuration.config);
  const apiRef = useGridApiRef();
  const gridActionMenuRef = useRef();
  const rootServiceUrl = useSelector(
    (state) => state.configuration.rootServiceUrl
  );
  const nifcToken = useSelector((state) => state.configuration.nifcToken);

  const useStyles = makeStyles({
    underline: {
      "&&&:before": {
        borderBottom: "2px solid red",
      },
      "&&:after": {
        borderBottom: "2px solid red",
      },
    },
    condensedFormControl: {
      margin: "5px 15px 5px 15px",
      minWidth: 120,
      width: "90%",
    },
    formControl: {
      margin: "10px 15px 10px 15px",
      minWidth: 120,
      width: "90%",
    },
    formControlHeader: {
      margin: "0px 15px 0px 15px",
      minWidth: 120,
      width: "90%",
    },
    snackBarStyle: {
      top: "120px !important",
    },
  });

  const useErrorStyles = makeStyles({
    underline: {
      "&&&:before": {
        borderBottom: "2px solid red"
      },
      "&&:after": {
        borderBottom: "2px solid red"
      }
    }
  });

  const classes = useStyles();
  const errorClasses = useErrorStyles();

  const WhiteAlien = "#ffffff";
  const BlueAlien = "#1976d2";
  const GreyAlien = "#808080";

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isFailure, setIsFailure] = useState(false);
  const [gridColumns, setGridColumns] = useState([]);
  const [gridRows, setGridRows] = useState([]);
  const [isGridLoading, setIsGridLoading] = useState(false);
  const [allSelectedItems, setAllSelectedItems] = useState([]);
  const gridSelectionLength =
    allSelectedItems && allSelectedItems.length > 0
      ? allSelectedItems.length
      : 0;
  const [areActionsLoading, setAreActionsLoading] = useState(false);
  const [isCarryoverQueryActive, setIsCarryoverQueryActive] = useState(false);
  const [isCarryoverLoading, setIsCarryoverLoading] =
    useState(false);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });
  const [totalCount, setTotalCount] = useState(0);
  const highestCount = gridRows ? Math.max(totalCount) : 0;
  const estPageCount = highestCount > 0 ? Math.ceil(highestCount / paginationModel.pageSize) : 1;
  const rowCountRef = React.useRef(highestCount || 0);
  const rowCount = React.useMemo(() => {
    if (highestCount !== undefined) {
      rowCountRef.current = highestCount;
    }
    return rowCountRef.current;
  }, [highestCount]);
  const currentMaxFrom = ((paginationModel.page) * paginationModel.pageSize);
  const currentMaxTo = ((paginationModel.page + 1) * paginationModel.pageSize);
  const fromCount = currentMaxFrom;

  const toCount = gridRows.length < 25 ? currentMaxFrom + gridRows.length : currentMaxTo;
  const rowHelpText = `The system will display up to ${paginationModel.pageSize} items per page. This page is displaying: \n  ${gridRows.length} Carryover Lines`

  const carryoverFeatureCols = [
    FieldNames.featureFields.objectID,
    FieldNames.featureFields.id,
    FieldNames.featureFields.joinID,
    FieldNames.featureFields.joinFeature,
    FieldNames.featureFields.entityType,
    FieldNames.featureFields.name,
    FieldNames.featureFields.class,
    FieldNames.featureFields.isCarryover,
    FieldNames.featureFields.isSubstitute,
    FieldNames.featureFields.isCanceled,
    FieldNames.featureFields.initiationDate,
    FieldNames.featureFields.initiationFiscalYear,
    FieldNames.featureFields.initiationFiscalQuarter,
    FieldNames.featureFields.originalInitiationDate,
    FieldNames.featureFields.hasActual
  ];
  const carryoverOutfieldStr = carryoverFeatureCols.join(",");

  const carryoverManagementGridColDefinitions = [
    GridDefinitions.CarryoverManagementGrid.entityID,
    GridDefinitions.CarryoverManagementGrid.name,
    GridDefinitions.CarryoverManagementGrid.entityType,
    GridDefinitions.CarryoverManagementGrid.isCarryover,
    GridDefinitions.CarryoverManagementGrid.isSubstitute,
    GridDefinitions.CarryoverManagementGrid.isCanceled,
  ];
  const carryoverAuditLogGridColDefinitions = [
    GridDefinitions.UserAuditLog.modifiedBy,
    GridDefinitions.UserAuditLog.modifiedOn,
    GridDefinitions.UserAuditLog.modification,
  ];

  const theme = createTheme({
    overrides: {
      palette: {
        red: {
          main: "#FF0000",
          light: "#FF0000",
          dark: "#FF0000",
          contrastText: "#242105",
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: "green",
        },
      },
      MuiOutlinedInput: {
        root: {
          "& $notchedOutline": {
            //initial border
            borderColor: BlueAlien,
          },
          "&:hover $notchedOutline": {
            //border on hover
            borderColor: BlueAlien,
            border: "2px solid",
          },
          "&$focused $notchedOutline": {
            //border on focus
            borderColor: BlueAlien,
            border: "2px solid",
          },
        },
      },
    },
  });

  const [fundingDepartmentSelection, setFundingDepartmentSelection] =
    useState(null);
  const [fundingAgencySelection, setFundingAgencySelection] = useState(null);
  const [fundingRegionSelection, setFundingRegionSelection] = useState(null);
  const [fundingUnitSelection, setFundingUnitSelection] = useState(null);
  const [fundingSubUnitSelection, setFundingSubUnitSelection] = useState(null);
  const [fundingTribeSelection, setFundingTribeSelection] = useState(null);
  const [entityTypeSelection, setEntityTypeSelection] = useState(null);
  const currLevelLabel =
    fundingTribeSelection &&
    fundingTribeSelection[FieldNames.budgetFields.tribe]
      ? "Tribe"
      : fundingSubUnitSelection &&
        fundingSubUnitSelection[FieldNames.budgetFields.subUnit]
      ? "SubUnit"
      : fundingUnitSelection &&
        fundingUnitSelection[FieldNames.budgetFields.unit]
      ? "Unit"
      : fundingRegionSelection &&
        fundingRegionSelection[FieldNames.budgetFields.region]
      ? "Region"
      : fundingAgencySelection &&
        fundingAgencySelection[FieldNames.budgetFields.agency]
      ? "Agency"
      : fundingDepartmentSelection
      ? "Department"
      : "Error";
  const currentSelectedLevel =
    currLevelLabel === "Department"
      ? fundingDepartmentSelection[FieldNames.budgetFields.department]
      : currLevelLabel === "Agency"
      ? fundingAgencySelection[FieldNames.budgetFields.agency]
      : currLevelLabel === "Region"
      ? fundingRegionSelection[FieldNames.budgetFields.region]
      : currLevelLabel === "Unit"
      ? fundingUnitSelection[FieldNames.budgetFields.unit]
      : currLevelLabel === "SubUnit"
      ? fundingSubUnitSelection[FieldNames.budgetFields.subUnit]
      : currLevelLabel === "Tribe"
      ? fundingTribeSelection[FieldNames.budgetFields.tribe]
      : "Error";

  const [fiscalYearSelection, setFiscalYearSelection] = useState(null);
  const [fiscalYearOptions, setFiscalYearOptions] = useState([]);
  const [
    carryoverTargetFiscalYearOptions,
    setCarryoverTargetFiscalYearOptions,
  ] = useState([]);
  const [isSelectedFiscalYearInFuture,setIsSelectedFiscalYearInFuture] = useState(false);

  const [groupFeatureFilterSelection, setGroupFeatureFilterSelection] =
    useState();
  const [groupFeatureFilterOptions, setGroupFeatureFilterOptions] = useState(
    []
  );
  const [groupFeatureFilterOpen, setGroupFeatureFilterOpen] = useState(false);
  const defaultGroupFeatureFilterOptions = [
    "N/A",
    "Incomplete Treatments and Activities",
    "Carryover Treatments and Activities",
    "Approved Incomplete Treatments and Activities",
  ];
  const showIncompleteFeatures =
    groupFeatureFilterSelection === defaultGroupFeatureFilterOptions[1];
  const showCarryoverFeatures =
    groupFeatureFilterSelection === defaultGroupFeatureFilterOptions[2];
  const showApprovedIncompleteFeatures =
    groupFeatureFilterSelection === defaultGroupFeatureFilterOptions[3];

  const groupFeatureFilterLoading =
    groupFeatureFilterOpen && groupFeatureFilterOptions.length === 0;

  const [currentRow, setCurrentRow] = useState(null);
  const [carryoverEditorOpen, setCarryoverEditorOpen] = useState(false);
  const [undoCarryoverPopupOpen, setUndoCarryoverPopupOpen] = useState(false);
  const [carryoverReasonOptions, setCarryoverReasonOptions] = useState([]);
  const [bulkCarryoverEditorOpen, setBulkCarryoverEditorOpen] = useState(false);
  const [bulkCarryoverReasoning, setBulkCarryoverReasoning] = useState("");
  const [bulkCarryoverReasonSelection, setBulkCarryoverReasonSelection] =
    useState("");
  const [bulkCarryoverReasonOpen, setBulkCarryoverReasonOpen] = useState(false);
  const bulkCarryoverReasonLoading =
    bulkCarryoverReasonOpen && carryoverReasonOptions.length === 0;
  const [
    carryoverBulkTargetFiscalYearSelection,
    setCarryoverBulkTargetFiscalYearSelection,
  ] = useState(null);

  const [carryoverHistoryOpen, setCarryoverHistoryOpen] = useState(false);
  const [carryoverHistoryRows, setCarryoverHistoryRows] = useState([]);
  const [carryoverHistoryCols, setCarryoverHistoryCols] = useState([]);

  const [cancelEditorOpen, setCancelEditorOpen] = useState(false);
  const [isBulkCancel, setIsBulkCancel] = useState(false);

  const [bulkConfirmOpen, setBulkConfirmOpen] = useState(false);

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    SubUnit: false,
    Tribe: false,
  });
  const [selectionModel, setSelectionModel] = useState({ids: new Set(), type: 'include'});
  const [aggregationModel, setAggregationModel] = useState({
    TotalBudget: "sum",
    RegularBudget: "sum",
    BILBudget: "sum",
    DisasterReliefBudget: "sum",
  });

  const [targetInitiationDateValue, setTargetInitiationDateValue] = useState(null);
  const [currentError, setCurrentError] = useState("");
  const [toShowError, setToShowError] = useState(false);

  const getDetailPanelContent = React.useCallback((row) => {
    return <CarryoverGridDetailPanel row={row} />;
  }, []);

  useEffect(() => {
    setShowMap(false);
  }, [setShowMap]);

  useEffect(() => {
    establishGridColumns();
    let fyList = [];
    let pastFyList = [];
    let futureFyList = [];
    let currFY = calculateFiscalYearQuarter(new Date(), true);
    if (currFY) {
      for (let i = 1; i <= 3; i++) {
        pastFyList.unshift(currFY - i);
        if (currFY + i <= currFY) {
          futureFyList.push(currFY + i);
        }
      }
      for (let i = 1; i <= 6; i++) {
        futureFyList.push(currFY + i);
      }
    }

    fyList = [...pastFyList, currFY, ...futureFyList];
    fyList = fyList.map((year) => {
      return { FiscalYear: `${year}` };
    });
    setFiscalYearOptions(fyList);
    setFiscalYearSelection({ FiscalYear: `${currFY}` });
  }, [config, rootServiceUrl]);

  useEffect(() => {
    if (
      !fiscalYearSelection ||
      !fiscalYearSelection[FieldNames.carryoverFields.fiscalYear]
    ) {
      return;
    }
    let targetFyList = [];
    let futureTargetFyList = [];
    let currFY = calculateFiscalYearQuarter(new Date(), true);
    let selectedFy = Number(
      fiscalYearSelection[FieldNames.carryoverFields.fiscalYear]
    );
    if (selectedFy) {
      if(selectedFy > currFY)
      {
        setIsSelectedFiscalYearInFuture(true);
      }
      else
      {
        setIsSelectedFiscalYearInFuture(false);
      }
      for (let i = 1; i <= 5; i++) {
        futureTargetFyList.push(selectedFy + i);
      }
    }

    targetFyList = futureTargetFyList;
    targetFyList = targetFyList.map((year) => {
      return { FiscalYear: `${year}` };
    });
    setCarryoverTargetFiscalYearOptions(targetFyList);
    setCarryoverBulkTargetFiscalYearSelection({ FiscalYear: `${selectedFy + 1}` });
  }, [fiscalYearSelection]);

  //
  // Manage Grid Rows
  //

  useEffect(() => {
    if (
      !entityTypeSelection ||
      !fiscalYearSelection ||
      (!fundingDepartmentSelection &&
        !fundingAgencySelection &&
        !fundingRegionSelection &&
        !fundingUnitSelection)
    ) {
      return;
    }

    if(totalCount === 0){
      getGridCarryoverTotalRowCount();
    }

    getGridCarryoverRows().then(() => {
      updateGridProperties();
    });
  }, [
    fiscalYearSelection,
    fundingDepartmentSelection,
    fundingAgencySelection,
    fundingRegionSelection,
    fundingUnitSelection,
    fundingSubUnitSelection,
    fundingTribeSelection,
    entityTypeSelection,
    showIncompleteFeatures,
    showCarryoverFeatures,
    showApprovedIncompleteFeatures,
    paginationModel
  ]);

  const getCombinedWhereClause = () => {
    let additionalEstWhereClause = ` AND (Class IN ('${FieldNames.classTypes.treatment}', '${FieldNames.classTypes.activity}'))`; // Estimates
    if (showIncompleteFeatures) {
      additionalEstWhereClause = ` AND (${FieldNames.featureFields.hasActual} IS NULL OR ${FieldNames.featureFields.hasActual} = 'No')`;
    } else if (showCarryoverFeatures) {
      additionalEstWhereClause = ` AND (${FieldNames.featureFields.isCarryover} IS NOT NULL AND ${FieldNames.featureFields.isCarryover} = 'Yes')`;
    } else if (showApprovedIncompleteFeatures) {
      additionalEstWhereClause = ` AND (${FieldNames.featureFields.hasActual} IS NULL OR ${FieldNames.featureFields.hasActual} = 'No') AND (${FieldNames.featureFields.departmentApprovalDate} IS NOT NULL)`;
    }
    const combinedWhereClause = additionalEstWhereClause;
    return combinedWhereClause;
  }

  const getGridCarryoverTotalRowCount = () => {
    if(!fundingDepartmentSelection || !fundingDepartmentSelection[FieldNames.budgetFields.department]
      || !fundingAgencySelection || !fundingAgencySelection[FieldNames.budgetFields.agency])
    {
      setGridRows([]);
      return;
    }

    const combinedWhereClause = getCombinedWhereClause();

    FeatureService.getFeatureByFundingFieldsCountForPaged(
      carryoverOutfieldStr,
      fundingDepartmentSelection,
      fundingAgencySelection,
      fundingRegionSelection,
      fundingUnitSelection,
      fundingSubUnitSelection,
      fundingTribeSelection,
      fiscalYearSelection,
      entityTypeSelection,
      combinedWhereClause).then((resp) => {
        setTotalCount(resp);
      }).catch(error => {
        ErrorService.addErrorLogEntry(userRoleInfo[FieldNames.userFields.nifcUsername], error);
      })
  }

  const getGridCarryoverRows = async () => {
    try{
      setAllSelectedItems([]);
      setSelectionModel({ids: new Set(), type: 'include'});

      if(!fundingDepartmentSelection || !fundingDepartmentSelection[FieldNames.budgetFields.department]
        || !fundingAgencySelection || !fundingAgencySelection[FieldNames.budgetFields.agency])
      {
        setGridRows([]);
        return;
      }

      setAreActionsLoading(true);

      // Fix by combining
      const combinedWhereClause = getCombinedWhereClause();

      let resp = await FeatureService.getFeaturesByFundingFieldsPaged(
        carryoverOutfieldStr,
        fundingDepartmentSelection,
        fundingAgencySelection,
        fundingRegionSelection,
        fundingUnitSelection,
        fundingSubUnitSelection,
        fundingTribeSelection,
        fiscalYearSelection,
        entityTypeSelection,
        combinedWhereClause,
        paginationModel.page,
        paginationModel.pageSize
      );

      if (resp?.length > 0) {
        // Map resp into single dataset matching grid cols
        let rows = resp.map((r) => {
          let rowObj = {
            OBJECTID: r[FieldNames.featureFields.objectID],
            EntityType: r[FieldNames.featureFields.entityType],
            Class: r[FieldNames.featureFields.class],
            EntityID: r[FieldNames.featureFields.objectID],
            ID: r[FieldNames.featureFields.id],
            FeatureID: r[FieldNames.featureFields.id],
            Name: r[FieldNames.featureFields.name],
            IsCarryover: r[FieldNames.featureFields.isCarryover] === FieldNames.yesNo.yes
              ? true
              : false,
            IsSubstitute: r[FieldNames.featureFields.isSubstitute] === FieldNames.yesNo.yes
              ? true
              : false,
            IsCanceled: r[FieldNames.featureFields.isCanceled] === FieldNames.yesNo.yes
              ? true
              : false,
            InitiationDate: r[FieldNames.featureFields.initiationDate],
            InitiationFiscalYear: r[FieldNames.featureFields.initiationFiscalYear],
            InitiationFiscalQuarter: r[FieldNames.featureFields.initiationFiscalQuarter],
            OriginalInitiationDate: r[FieldNames.featureFields.originalInitiationDate],
            JoinID: r[FieldNames.featureFields.joinID],
            JoinFeature: r[FieldNames.featureFields.joinFeature],
            HasActual: r[FieldNames.featureFields.hasActual]
          };
          return rowObj;
        });

        const polygonRowIDs = rows.filter(r =>
          r[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.polygon).map((r) => {
          return r[FieldNames.carryoverFields.joinID];
        });
        const lineRowIDs = rows.filter(r =>
          r[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.line).map((r) => {
          return r[FieldNames.carryoverFields.joinID];
        });
        const pointRowIDs = rows.filter(r =>
          r[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.point).map((r) => {
          return r[FieldNames.carryoverFields.joinID];
        });

        let carryRows = [];
        let cancelRows = [];
        let finalRows = rows;

        try{
          const polygonCarryResp = CarryoverService.getLatestMultipleFeaturesCarryoverEntry(FieldNames.joinFeatureValues.polygon, polygonRowIDs) ?? [];
          const lineCarryResp = CarryoverService.getLatestMultipleFeaturesCarryoverEntry(FieldNames.joinFeatureValues.line, lineRowIDs) ?? [];
          const pointCarryResp = CarryoverService.getLatestMultipleFeaturesCarryoverEntry(FieldNames.joinFeatureValues.point, pointRowIDs) ?? [];
          let carryoverValues = await Promise.all([polygonCarryResp, lineCarryResp, pointCarryResp]);
          let combinedValues = [].concat(...carryoverValues);
          carryRows = rows.map((obj) => {
            let carryoverEntry =
              combinedValues.find(
                (o) =>
                  obj[FieldNames.carryoverFields.joinID] ===
                o[FieldNames.carryoverFields.joinID] &&
                obj[FieldNames.carryoverFields.joinFeature] ===
                o[FieldNames.carryoverFields.joinFeature]
              ) || obj;

            let combinedRow = { ...obj, ...carryoverEntry };
            return combinedRow;
          });
          // Added check to make sure data matches
          finalRows = carryRows?.length === rows?.length ? carryRows : rows;
        }
        catch(e)
        {
          ErrorService.addErrorLogEntry(userRoleInfo[FieldNames.userFields.nifcUsername], e);
        }

        try{
          const polygonCancelResp = CancelService.getMultipleFeaturesCancelEntry(FieldNames.joinFeatureValues.polygon, polygonRowIDs) ?? [];
          const lineCancelResp = CancelService.getMultipleFeaturesCancelEntry(FieldNames.joinFeatureValues.line, lineRowIDs) ?? [];
          const pointCancelResp = CancelService.getMultipleFeaturesCancelEntry(FieldNames.joinFeatureValues.point, pointRowIDs) ?? [];
          let cancelValues = await Promise.all([polygonCancelResp, lineCancelResp, pointCancelResp]);
          let combinedValues = [].concat(...cancelValues);
          cancelRows = finalRows.map((obj) => {
            let cancelEntry =
              combinedValues.find(
                (o) =>
                  obj[FieldNames.carryoverFields.joinID] ===
                o[FieldNames.carryoverFields.joinID] &&
                obj[FieldNames.carryoverFields.joinFeature] ===
                o[FieldNames.carryoverFields.joinFeature]
              ) || obj;

            let combinedRow = { ...obj, ...cancelEntry };
            return combinedRow;
          });
          // Added check to make sure data matches
          finalRows = cancelRows?.length === finalRows?.length ? cancelRows : finalRows;
        }
        catch(e)
        {
          ErrorService.addErrorLogEntry(userRoleInfo[FieldNames.userFields.nifcUsername], e);
        }

        setGridRows(finalRows);
        setAreActionsLoading(false);
      }
      else
      {
        setGridRows([]);
        setAreActionsLoading(false);
      }
    }
    catch(error)
    {
      setGridRows([]);
      setAreActionsLoading(false);
      ErrorService.addErrorLogEntry(userRoleInfo[FieldNames.userFields.nifcUsername], error);
    }
  };

  useEffect(() => {
    const isQueryActive = areActionsLoading;
    setIsGridLoading(isQueryActive); //Simplify
  }, [
    areActionsLoading,
  ]);

  useEffect(() => {
    if (
      (isCarryoverLoading) &&
      !isCarryoverQueryActive
    ) {
      setIsGridLoading(true);
      setIsCarryoverQueryActive(true);
    }

    if (
      !isCarryoverLoading &&
      isCarryoverQueryActive
    ) {
      setIsCarryoverQueryActive(false);
      if(totalCount === 0){
        getGridCarryoverTotalRowCount();
      }
      getGridCarryoverRows();
    }
  }, [
    isCarryoverLoading
    // intentionally excluding isCarryoverQueryActive
  ]);

  useEffect(() => {
    if (!groupFeatureFilterLoading) {
      return undefined;
    }

    setGroupFeatureFilterOptions(defaultGroupFeatureFilterOptions);
  }, [groupFeatureFilterLoading, config, rootServiceUrl]);

  useEffect(() => {
    let active = true;

    if (!bulkCarryoverReasonLoading) {
      return undefined;
    }

    (async () => {
      if (active) {
        setCarryoverReasonOptions([]);

        CarryoverService.getCarryoverReasons().then(
          (response) => {
            setCarryoverReasonOptions(response);
          }
        );
      }
    })();

    return () => {
      active = false;
    };
  }, [
    bulkCarryoverReasonLoading
  ]);

  const getURLPath = (params) => {
    let feature = params.row;
    // On Carryover grid, entityID refers the objectID of the Action
    // TODO: we should change the variable name for this grid data to be more clear on that in the future
    const objectIDofFeature = feature[FieldNames.featureFields.entityID];
    const isTreatment = isFeatureTreatment(false, feature, FieldNames.featureFields);
    const isPostFire = isFeaturePostFire(feature, false);
    const entityString = isTreatment ? "treatments" : "activities";
    const entityTypeString = isPostFire ? "pf" : "f";
    const url = `../${entityTypeString}/${entityString}/${objectIDofFeature}`;
    return url;
  };

  const establishGridColumns = (disableEditActions = false) => {
    let columns = [];
    carryoverManagementGridColDefinitions.forEach((colDef) => {
      columns.push({
        field: colDef.value,
        headerName: colDef.header,
        type: colDef.type,
        hideable: colDef.hideable,
        sortable: colDef.sortable,
        editable: colDef.editable,
        flex: colDef.flex,
        align: colDef.align,
        disableExport: colDef.disableExport,
        valueFormatter: (value) => {
          return value;
        },
        renderCell: (params) => {
          if (colDef.value === FieldNames.featureFields.name) {
            return (
              <Tooltip title={params.value}>
                <a href={getURLPath(params)}>{params.value}</a>
              </Tooltip>
            );
          } else if (
            colDef.value === FieldNames.featureFields.isCarryover ||
            colDef.value === FieldNames.featureFields.isCanceled ||
            colDef.value === FieldNames.featureFields.isSubstitute
          ) {
            return (
              <Checkbox
                disabled
                checked={params.value && params.value === true}
                style={{
                  color: params.value ? theme.palette.success.light : GreyAlien,
                }}
              />
            );
          } else {
            return <>{params.value}</>;
          }
        },
      });
    });

    columns.push({
      field: "actions",
      headerName: "Actions",
      hideable: true,
      sortable: false,
      editable: false,
      flex: 0.75,
      align: "center",
      disableExport: true,
      // Render Cell allows you to set entire components within a cell for custom buttons/functionality
      renderCell: (params) => {
        return params.rowNode.type == "group" ? null : (
          <MuiMenuDropdown buttonText={"Actions"} ref={gridActionMenuRef}>
            <Tooltip title={params?.row?.[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes ? "Estimated Action has an Actual" : ""}>
              <span>
                <MenuItem
                  onClick={(e) => {
                    assignCarryoverRow(e, params.row);
                  }}
                  disabled={disableEditActions || params?.row?.[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes}
                  disableRipple
                >
                  <KeyboardTabIcon />
                  Set Carryover Status
                </MenuItem>
              </span>
            </Tooltip>
            {
              params?.row?.IsCarryover &&
              <Tooltip title={params?.row?.[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes ? "Estimated Action has an Actual" : ""}>
                <span>
                  <MenuItem
                    onClick={(e) => {
                      undoCarryoverRow(e, params.row);
                    }}
                    disabled={disableEditActions || params?.row?.[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes}
                    disableRipple
                  >
                    <UndoIcon />
                    Undo Last Carryover
                  </MenuItem>
                </span>
              </Tooltip>
            }
            <Tooltip title={params?.row?.[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes ? "Estimated Action has an Actual" : ""}>
              <span>
                <MenuItem
                  onClick={(e) => {
                    cancelRow(e, params.row);
                  }}
                  disabled={disableEditActions || params?.row?.[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes}
                  disableRipple
                >
                  <CancelIcon />
                  Cancel Feature
                </MenuItem>
              </span>
            </Tooltip>
            <MenuItem
              onClick={(e) => {
                viewHistoryRow(e, params.row);
              }}
              disableRipple
            >
              <HistoryIcon />
              View History
            </MenuItem>
          </MuiMenuDropdown>
        );
      },
    });

    setGridColumns(columns);
  };

  const updateGridProperties = () => {
    if(!apiRef)
    {
      return;
    }

    establishGridColumns(false);
  }

  const assignCarryoverRow = (e, row) => {
    setCarryoverEditorOpen(true);
    setCurrentRow(row);
    gridActionMenuRef.current.handleCloseExternal();
  };

  const undoCarryoverRow = (e, row) => {
    setUndoCarryoverPopupOpen(true);
    setCurrentRow(row);
    gridActionMenuRef.current.handleCloseExternal();
  }

  const cancelRow = (e, row) => {
    setCancelEditorOpen(true);
    setIsBulkCancel(false);
    setCurrentRow(row);
    gridActionMenuRef.current.handleCloseExternal();
  };

  const bulkCancel = (e) => {
    setCancelEditorOpen(true);
    setIsBulkCancel(true);
  };

  const assignBulkCarryover = (e) => {
    setBulkCarryoverEditorOpen(true);
    setBulkCarryoverReasonSelection("");
    setBulkCarryoverReasoning("");
  };

  const carryoverSaveCallback = () => {
    getGridCarryoverTotalRowCount();
    getGridCarryoverRows();
    setCurrentRow(null);
  }

  const saveBulkCarryoverValue = () => {
    if (
      !bulkCarryoverReasonSelection ||
      !carryoverBulkTargetFiscalYearSelection ||
      !allSelectedItems ||
      allSelectedItems.length === 0
    ) {
      return;
    }

    setIsCarryoverLoading(true);

    let currentFySelection = Number(
      fiscalYearSelection[FieldNames.carryoverFields.fiscalYear]
    );
    let targetBulkFySelection = Number(
      carryoverBulkTargetFiscalYearSelection[
        FieldNames.carryoverFields.fiscalYear
      ]
    );
    let baseMessage = `Feature was marked as carryover from FY${currentFySelection} to FY${targetBulkFySelection} for the following reason: ${bulkCarryoverReasonSelection}`;
    let auditLogMessage = bulkCarryoverReasoning
      ? (baseMessage + ". " + bulkCarryoverReasoning)
      : baseMessage;

    let featuresToUpdate = [];
    let carryOverRowsToAdd = [];

    allSelectedItems.forEach((carryoverRow) => {
      let newCarryoverObj = {
        JoinID: carryoverRow[FieldNames.featureFields.joinID],
        JoinFeature: carryoverRow[FieldNames.featureFields.joinFeature],
        EntityID: carryoverRow[FieldNames.featureFields.entityID],
        EntityObjectID: carryoverRow[FieldNames.featureFields.objectID],
        EntityType: carryoverRow[FieldNames.featureFields.entityType],
        Reason: bulkCarryoverReasonSelection,
        CurrentFiscalYear: currentFySelection,
        TargetFiscalYear: targetBulkFySelection,
        CreatedBy: currentUserInfo[FieldNames.userFields.nifcUsername],
        CreatedOnDate: getSaveableDate(new Date()),
        ModifiedBy: currentUserInfo[FieldNames.userFields.nifcUsername],
        ModifiedDate: getSaveableDate(new Date()),
        IsArchived: FieldNames.yesNo.no,
      };

      let featureObj = {
        OBJECTID: carryoverRow[FieldNames.featureFields.entityID],
        ID: carryoverRow[FieldNames.featureFields.id],
        IsCarryover: "Yes",
        CarryoverFiscalYear: targetBulkFySelection,
        InitiationDate: getSaveableDate(targetInitiationDateValue),
        InitiationFiscalYear: targetBulkFySelection,
        InitiationFiscalQuarter: calculateFiscalYearQuarter(new Date(targetInitiationDateValue), false)
      };

      if(!carryoverRow[FieldNames.featureFields.originalInitiationDate])
      {
        // Set original initiation date values if they have not been set before
        featureObj[FieldNames.featureFields.originalInitiationDate] = getSaveableDate(carryoverRow[FieldNames.featureFields.initiationDate]);
        featureObj[FieldNames.featureFields.originalInitiationFiscalYear] = carryoverRow[FieldNames.featureFields.initiationFiscalYear];
        featureObj[FieldNames.featureFields.originalInitiationFiscalQuarter] = carryoverRow[FieldNames.featureFields.initiationFiscalQuarter];
      }

      featuresToUpdate.push(featureObj);
      carryOverRowsToAdd.push(newCarryoverObj);
    });

    if (featuresToUpdate.length > 0) {
      bulkUpdateProcess(
        featuresToUpdate,
        carryOverRowsToAdd,
        auditLogMessage
      );
    }
    else
    {
      setIsCarryoverLoading(false);
    }
  };

  const bulkUpdateProcess = async (
    featureArr,
    carryoverArr,
    auditLogMessage
  ) => {
    try
    {
      let resp = await FeatureService.updateMultipleFeaturesAttributes(featureArr);
      if (resp?.successful && resp?.successful?.length > 0) {
        let objIDArray = resp?.successful;
        const arrToCarryover = carryoverArr?.filter(feature => objIDArray.includes(feature["EntityObjectID"]));
        const cresp = await CarryoverService.addMultipleCarryoverEntries(arrToCarryover);
        const auditList = arrToCarryover?.map(row => {
          return {
            [FieldNames.auditLogFields.joinID]: row[FieldNames.auditLogFields.joinID],
            [FieldNames.auditLogFields.joinFeature]: row[FieldNames.auditLogFields.joinFeature],
            [FieldNames.featureFields.entityType]: row[FieldNames.featureFields.entityType],
            [FieldNames.featureFields.entityID]: row[FieldNames.featureFields.entityID]
          }
        })
        const polyList = auditList.filter(x => x[FieldNames.auditLogFields.joinFeature] === FieldNames.auditLogJoinTypes.polygon);
        const lineList = auditList.filter(
          (x) =>
            x[FieldNames.auditLogFields.joinFeature] ===
            FieldNames.auditLogJoinTypes.line
        );
        const pointList = auditList.filter(x => x[FieldNames.auditLogFields.joinFeature] === FieldNames.auditLogJoinTypes.point);

        try
        {
          const polyResp = AuditLogService.addMultipleAuditLogs(
            FieldNames.auditLogJoinTypes.polygon,
            polyList,
            currentUserInfo[FieldNames.userFields.nifcUsername],
            auditLogMessage
          );

          const lineResp = AuditLogService.addMultipleAuditLogs(
            FieldNames.auditLogJoinTypes.line,
            lineList,
            currentUserInfo[FieldNames.userFields.nifcUsername],
            auditLogMessage
          );

          const pointResp = AuditLogService.addMultipleAuditLogs(
            FieldNames.auditLogJoinTypes.point,
            pointList,
            currentUserInfo[FieldNames.userFields.nifcUsername],
            auditLogMessage
          );

          let allResp = await Promise.all([polyResp, lineResp, pointResp]);
        }
        catch(e)
        {
          ErrorService.addErrorLogEntry(userRoleInfo[FieldNames.userFields.nifcUsername], e);
        }
      }
    }
    catch(e)
    {
      ErrorService.addErrorLogEntry(userRoleInfo[FieldNames.userFields.nifcUsername], e);
    }
    finally
    {
      setCurrentRow(null);
      setTargetInitiationDateValue(null);
      setBulkCarryoverReasoning("");
      setBulkCarryoverReasonSelection("");
      setIsCarryoverLoading(false);
    }
  };

  const viewHistoryRow = (e, row) => {
    establishHistoryGridColumns();
    getCarryoverAuditLog(
      row[FieldNames.featureFields.joinFeature],
      row[FieldNames.featureFields.joinID]
    );
    gridActionMenuRef.current.handleCloseExternal();
  };

  const establishHistoryGridColumns = () => {
    let columns = [];
    carryoverAuditLogGridColDefinitions.forEach((colDef) => {
      columns.push({
        field: colDef.value,
        headerName: colDef.header,
        type: colDef.type,
        hideable: colDef.hideable,
        sortable: colDef.sortable,
        editable: colDef.editable,
        flex: colDef.flex,
        align: colDef.align,
        disableExport: colDef.disableExport,
        valueGetter: (value) => {
          return value; // Used for formatting string values I.E. currency formatting
        },
      });
    });

    setCarryoverHistoryCols(columns);
  };

  //
  // General Page Methods
  //

  const handleClose = () => {
    setShowMap(true);
    navigate("/home");
  };

  const closeBulkCarryoverEditor = () => {
    setBulkCarryoverEditorOpen(false);
    setTargetInitiationDateValue(null);
    setBulkCarryoverReasoning("");
    setBulkCarryoverReasonSelection("");
  };

  const closeCancelEditorCallback = () => {
    setCurrentRow(null);
  }

  const saveCancelEditorCallback = () => {
    setTotalCount(0)
    getGridCarryoverTotalRowCount();
    getGridCarryoverRows();
    setTargetInitiationDateValue(null);
  }

  const closeCarryoverHistory = () => {
    setCarryoverHistoryOpen(false);
  };

  const getCarryoverAuditLog = (joinFeature, joinID) => {
    if (joinID) {
      setCarryoverHistoryOpen(true);
      setCarryoverHistoryRows([]);

      AuditLogService.getEntityAuditLog(
        joinFeature,
        joinID
      ).then((auditRows) => {
        if (auditRows && auditRows.length > 0) {
          var mappedRows = auditRows.map((auditRow) => {
            let modMessage = "";
            try{
              modMessage = JSON.parse(auditRow.AuditEntryJson)[0]
            } catch(e){
              modMessage = auditRow.AuditEntryJson
            }
            return {
              id: auditRow[FieldNames.featureFields.objectID],
              ModifiedBy: auditRow.ModifiedBy,
              ModifiedDate: formatDateForDisplay(auditRow.ModifiedDate),
              Modification: modMessage,
            };
          });
          setCarryoverHistoryRows(mappedRows);
        } else {
          setCarryoverHistoryRows([]);
        }
        setCarryoverHistoryOpen(true);
      });
    } else {
      setCarryoverHistoryOpen(true);
      setCarryoverHistoryRows([]);
    }
  };

  // --- Grid Logic ---

  const exportOptions = {
    getRowsToExport: () => gridFilteredSortedRowIdsSelector(apiRef),
  };

    function CustomPagination({
                                  page,
                                  onPageChange,
                                  className,
                              }) {
        const apiRef = useGridApiContext();
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);
        if (gridRows?.length) {
            return (
                <>
                    <Tooltip
                        title={
                            <div style={{whiteSpace: 'pre-line'}}>{rowHelpText}</div>
                        }
                        enterDelay={100}
                    >
                        <HelpIcon fontSize="small" color="primary" style={{paddingLeft: 5}}/>
                    </Tooltip>

                    {isGridLoading ? (
                        <Box sx={{
                            paddingRight: "15px !important",
                            paddingLeft: "15px !important",
                            paddingTop: "5px !important",
                            paddingBottom: "5px !important"
                        }}>
                            <CircularProgress size="1.5rem"></CircularProgress>
                        </Box>
                    ) : (
                        <MuiPagination
                            color="primary"
                            className={className}
                            count={pageCount}
                            page={page + 1}
                            onChange={(event, newPage) => {
                                onPageChange(event, newPage - 1);
                            }}
                        />
                    )}
                </>
            )
        } else {
            return null;
        }
    }

  function CustomExportContainer(props) {
    return (
      <GridToolbarExportContainer {...props}>
        <GridCsvExportMenuItem
          options={exportOptions}
          onClick={() => apiRef.current.exportDataAsCsv(exportOptions)}
        />
        <GridExcelExportMenuItem
          options={exportOptions}
          onClick={() => apiRef.current.exportDataAsExcel(exportOptions)}
        />
      </GridToolbarExportContainer>
    );
  }

  function CustomCarryoverGridToolbar(props) {
    const doAnySelectedItemHaveActual = allSelectedItems?.some(x => x[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes)
    return (
      <GridToolbarContainer>
        <MuiMenuDropdown
          buttonText={"Bulk Actions"}
          dropdownDisabled={!allSelectedItems
          || allSelectedItems.length <= 0
          || doAnySelectedItemHaveActual
          || isSelectedFiscalYearInFuture}
          ref={gridActionMenuRef}
          tooltipText = {(!allSelectedItems || allSelectedItems.length <= 0) ? "Must have rows selected"
            : isSelectedFiscalYearInFuture ? "Can't run bulk actions on future fiscal years"
            : doAnySelectedItemHaveActual ? "Estimated Action has an Actual" : ""}
        >
          <MenuItem
            onClick={(e) => {
              assignBulkCarryover();
            }}
            disableRipple
          >
            <KeyboardTabIcon />
            Bulk Set Carryover Status
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              bulkCancel();
            }}
            disableRipple
          >
            <CancelIcon />
            Bulk Cancel
          </MenuItem>
        </MuiMenuDropdown>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <CustomExportContainer />
      </GridToolbarContainer>
    );
  }

  return (
    <Box>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: BlueAlien, marginTop: headerheight }}
      >
        <Toolbar>
          <FormControl variant="standard" className={classes.formControl}>
            <ThemeProvider theme={theme}>
              <Grid
                item
                size={12}

                container
                direction="row"
                className="grid-item"
                style={{ alignItems: "center" }}
              >
                <Grid item size={0.2}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                  >
                    <CloseIcon style={{ fill: WhiteAlien }} />
                  </IconButton>
                </Grid>
                <Grid item size={4}>
                  <Typography
                    sx={{ ml: 2, flex: 1 }}
                    variant="h6"
                    component="div"
                    style={{ color: WhiteAlien }}
                  >
                    Carryover Management
                  </Typography>
                </Grid>
                <WorkflowFiscalYearFilter
                  fiscalYearSelection={fiscalYearSelection}
                  setFiscalYearSelection={setFiscalYearSelection}
                  fiscalYearOptions={fiscalYearOptions}
                  setTotalCount={setTotalCount}
                />
              </Grid>
            </ThemeProvider>
          </FormControl>
        </Toolbar>
      </AppBar>
      <Paper style={{ maxHeight: "85vh", overflow: "auto" }}>
        <Box
          sx={{
            width: "100%",
            minWidth: "10px",
          }}
        >
          <WorkflowGridFilters
            currentUserInfo={currentUserInfo}
            userRoleInfo={userRoleInfo}
            fundingDepartmentSelection={fundingDepartmentSelection}
            setFundingDepartmentSelection={setFundingDepartmentSelection}
            fundingAgencySelection={fundingAgencySelection}
            setFundingAgencySelection={setFundingAgencySelection}
            fundingRegionSelection={fundingRegionSelection}
            setFundingRegionSelection={setFundingRegionSelection}
            fundingUnitSelection={fundingUnitSelection}
            setFundingUnitSelection={setFundingUnitSelection}
            fundingSubUnitSelection={fundingSubUnitSelection}
            setFundingSubUnitSelection={setFundingSubUnitSelection}
            fundingTribeSelection={fundingTribeSelection}
            setFundingTribeSelection={setFundingTribeSelection}
            entityTypeSelection={entityTypeSelection}
            setEntityTypeSelection={setEntityTypeSelection}
            setColumnVisibilityModel={setColumnVisibilityModel}
            setTotalCount={setTotalCount}
          />
          <Grid container>
            <FormControl variant="standard" className={classes.formControl}>
              <ThemeProvider theme={theme}>
                <Grid
                  item
                  size={12}

                  container
                  direction="row"
                  className="grid-item"
                  style={{ alignItems: "center" }}
                >
                  <Grid item size={2}>
                    <span>
                      <label>Filter Options</label>
                    </span>
                  </Grid>
                  <Grid item size={3}>
                    <Autocomplete
                      //multiple
                      disableClearable
                      id="groupFeatureDemo"
                      value={groupFeatureFilterSelection}
                      onChange={(event, newValue) => {
                        if (newValue === "N/A") {
                          newValue = "";
                        }
                        setGroupFeatureFilterSelection(newValue);
                        setTotalCount(0);
                      }}
                      onOpen={() => {
                        setGroupFeatureFilterOpen(true);
                      }}
                      onClose={() => {
                        setGroupFeatureFilterOpen(false);
                      }}
                      isOptionEqualToValue={(option, value) => option === value}
                      getOptionLabel={(option) => {
                        return option;
                      }}
                      options={groupFeatureFilterOptions}
                      getOptionDisabled={(option) => {
                        if (groupFeatureFilterSelection) {
                          const selected = groupFeatureFilterSelection;
                          if (selected && option && selected === option) {
                            return true;
                          } else {
                            return false;
                          }
                        } else {
                          return false;
                        }
                      }}
                      loading={groupFeatureFilterLoading}
                      renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                          <Chip
                            label={option}
                            {...getTagProps({ index })}
                            disabled={false}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          slotProps={{
                            input: {
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {groupFeatureFilterLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params?.InputProps?.endAdornment}
                                </React.Fragment>
                              )
                            }
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                {
                  (!fundingDepartmentSelection || !fundingDepartmentSelection[FieldNames.budgetFields.department]
                  || !fundingAgencySelection || !fundingAgencySelection[FieldNames.budgetFields.agency]) ?
                  <Grid
                  item
                  size={12}

                  container
                  direction="row"
                  className="grid-item"
                  style={{ alignItems: "center" }}
                >
                  <Grid item size={5}>
                    <Box sx={{ backgroundColor: "#D3D3D3", marginTop: "10px"}}
                        style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap'}}>
                      <HelpIcon fontSize="small" color="primary" style={{ paddingRight: "5px" }}/>
                      <Typography fontSize={12}>
                        A Department and Agency must be selected to show data in the grid
                      </Typography>
                    </Box>
                  </Grid>
                </Grid> : null
                }
              </ThemeProvider>
            </FormControl>
          </Grid>
        </Box>
        <CarryoverEntryPopup
          currentUserInfo={currentUserInfo}
          userRoleInfo={userRoleInfo}
          carryoverEditorOpen={carryoverEditorOpen}
          setCarryoverEditorOpen={setCarryoverEditorOpen}
          carryoverReasonOptions={carryoverReasonOptions}
          setCarryoverReasonOptions={setCarryoverReasonOptions}
          feature={currentRow}
          presetInitationFiscalYear={fiscalYearSelection}
          saveCallback={carryoverSaveCallback}
        />
        <UndoCarryoverPopup
          currentUserInfo={currentUserInfo}
          userRoleInfo={userRoleInfo}
          carryoverEditorOpen={undoCarryoverPopupOpen}
          setCarryoverEditorOpen={setUndoCarryoverPopupOpen}
          feature={currentRow}
          presetInitationFiscalYear={fiscalYearSelection}
          saveCallback={carryoverSaveCallback}
        />
        <CancelEntryPopup
          currentUserInfo={currentUserInfo}
          userRoleInfo={userRoleInfo}
          cancelEditorOpen={cancelEditorOpen}
          setCancelEditorOpen={setCancelEditorOpen}
          closeCallback={closeCancelEditorCallback}
          saveCallback={saveCancelEditorCallback}
          isBulkCancel={isBulkCancel}
          allBulkSelectedItems={allSelectedItems}
          feature={currentRow}
        />
        <InFormGenericModal
          openFlag={bulkCarryoverEditorOpen}
          closeMethod={closeBulkCarryoverEditor}
          titleText={"Edit Carryover In Bulk"}
          displayButton={false}
        >
          <Box
            style={{
              maxHeight: "300px",
              overflow: "auto",
              width: "100%",
              minWidth: "450px",
            }}
          >
            <FormControl variant="standard" className={classes.formControl}>
              <ThemeProvider theme={theme}>
                <Grid
                  item
                  size={12}

                  container
                  direction="row"
                  className="grid-item"
                  style={{ alignItems: "center" }}
                >
                  <Typography>
                    You have selected {gridSelectionLength} rows to assign the
                    following carryover status. Please review before confirming
                  </Typography>
                  <Grid item size={12}>
                    <Typography display={"inline"}>
                      Carryover Reason:{" "}
                    </Typography>
                    <Typography display={"inline"} color={"red"}>
                      {" "}
                      *
                    </Typography>
                  </Grid>
                  <Grid item size={12}>
                    <Autocomplete
                      //multiple
                      disableClearable
                      id="budgetBucketMulti"
                      open={bulkCarryoverReasonOpen}
                      value={bulkCarryoverReasonSelection}
                      onChange={(event, newValue) => {
                        if (newValue === "N/A") {
                          newValue = "";
                        }
                        setBulkCarryoverReasonSelection(newValue);
                      }}
                      onOpen={() => {
                        setBulkCarryoverReasonOpen(true);
                      }}
                      onClose={() => {
                        setBulkCarryoverReasonOpen(false);
                      }}
                      isOptionEqualToValue={(option, value) => {
                        return option === value || value === "";
                      }}
                      getOptionLabel={(option) => {
                        return option;
                      }}
                      options={carryoverReasonOptions}
                      getOptionDisabled={(option) => {
                        if (bulkCarryoverReasonSelection) {
                          const selected = bulkCarryoverReasonSelection;
                          if (selected && option && selected === option) {
                            return true;
                          } else {
                            return false;
                          }
                        } else {
                          return false;
                        }
                      }}
                      loading={bulkCarryoverReasonLoading}
                      renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                          <Chip
                            label={option}
                            {...getTagProps({ index })}
                            disabled={false}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          slotProps={{
                            input: {
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {bulkCarryoverReasonLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params?.InputProps?.endAdornment}
                                </React.Fragment>
                              )
                            }
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={12}>
                    <Typography display={"inline"}>
                      Target Initiation Date:{" "}
                    </Typography>
                    <Typography display={"inline"} color={"red"}>
                      {" "}
                      *
                    </Typography>
                  </Grid>
                  <Grid item size={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      format="MM/dd/yyyy"
                      fullWidth
                      clearable
                      clearText="Clear"
                      {... (!targetInitiationDateValue) ? {InputProps: { errorClasses }} : { InputProps: {}}}
                      id={`datePicker-date`}
                      value={targetInitiationDateValue}
                      onChange={(value) => handleBulkCarryoverTargetInitDateChange(value, setTargetInitiationDateValue, setCurrentError, setToShowError, setCarryoverBulkTargetFiscalYearSelection, allSelectedItems)}
                      slotProps={{
                        textField: {
                          helperText: toShowError ? currentError ?? "" : "",
                          error: toShowError
                        },
                      }}
                    />
                  </LocalizationProvider>
                  </Grid>
                  <Grid item size={12}>
                    <Typography display={"inline"}>
                      Target Fiscal Year:{" "}
                    </Typography>
                    <Typography display={"inline"} color={"red"}>
                      {" "}
                      *
                    </Typography>
                    <Tooltip title={`Value is derived from the chosen initiation date`}>
                      <IconButton style={{ padding: 0 }} aria-label="Help">
                        <HelpIcon fontSize="small" color="primary" style={{ right: "0px" }} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item size={12}>
                    <WorkflowFiscalYearFilter
                      fiscalYearSelection={
                        carryoverBulkTargetFiscalYearSelection
                      }
                      setFiscalYearSelection={
                        setCarryoverBulkTargetFiscalYearSelection
                      }
                      fiscalYearOptions={carryoverTargetFiscalYearOptions}
                      hideFiscalYearHeader={true}
                      isDisabled={true}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  size={12}

                  container
                  direction="row"
                  className="grid-item"
                  style={{ alignItems: "center" }}
                >
                  <Grid item size={12}>
                  <BasicTextField
                    field="carryoverReason"
                    label=""
                    setValue={setBulkCarryoverReasoning}
                    variant={"outlined"}
                    placeholder={"Enter notes for carryover"}
                    useFullWidth={true}
                  />
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <Box sx={{ marginLeft: "60%", marginBottom: "5px" }}>
              <Button
                variant="outlined"
                onClick={() => {
                  setBulkCarryoverReasonSelection("");
                  setBulkCarryoverReasoning("");
                  setBulkCarryoverEditorOpen(false);
                }}
                aria-label="cancel"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  saveBulkCarryoverValue();
                  setBulkCarryoverEditorOpen(false);
                  setTotalCount(0)
                }}
                disabled={
                  !carryoverBulkTargetFiscalYearSelection ||
                  toShowError ||
                  !bulkCarryoverReasonSelection ||
                  !allSelectedItems ||
                  allSelectedItems.length === 0
                }
                aria-label="edit"
                sx={{ marginLeft: "5px" }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </InFormGenericModal>
        <InFormGenericModal
          openFlag={carryoverHistoryOpen}
          closeMethod={closeCarryoverHistory}
          titleText={"Feature History"}
          displayButton={false}
        >
          <Box
            style={{
              maxHeight: "300px",
              overflow: "auto",
              width: "66%",
              minWidth: "800px",
            }}
          >
            <FormControl variant="standard" className={classes.formControl}>
              <ThemeProvider theme={theme}>
                <Box sx={{ height: "250px", width: "100%", minWidth: "10px" }}>
                  <DataGridPremium
                    rows={carryoverHistoryRows}
                    columns={carryoverHistoryCols}
                  ></DataGridPremium>
                </Box>
              </ThemeProvider>
            </FormControl>
            <Box sx={{ marginLeft: "80%", marginBottom: "5px" }}>
              <Button
                variant="outlined"
                onClick={() => setCarryoverHistoryOpen(false)}
              >
                Close
              </Button>
            </Box>
          </Box>
        </InFormGenericModal>
        <Box
          sx={{
            height: "625px", //525
            width: "100%",
            minWidth: "10px",
            //paddingTop: "50px !important",
            paddingBottom: "100px !important",
          }}
        >
            <DataGridPremium
                showToolbar
                apiRef={apiRef}
                getRowId={(row) =>
                    row[FieldNames.featureFields.entityType] +
                    "-" +
                    row[FieldNames.featureFields.entityID]
                }
                rows={gridRows}
                columns={gridColumns}
                slots={{
                    toolbar: CustomCarryoverGridToolbar
                }}
                slotProps={{
                    basePagination: {
                        material: {
                            ActionsComponent: CustomPagination,
                        },
                    },
                }}
                rowsPerPageOptions={[25]}
                rowCount={rowCount}
                pagination
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[25]}
                loading={isGridLoading}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) =>
                    setColumnVisibilityModel(newModel)
                }
                checkboxSelection
                disableRowSelectionOnClick
                rowSelectionModel={selectionModel}
                onRowSelectionModelChange={(newSelection) => {
                    setSelectionModel(newSelection);
                    let selectedItems = [];
                    newSelection.ids.forEach((item) => {
                        const group = apiRef.current.getRowNode(item);
                        let selectedGridValue;
                        if (
                            group.groupingField
                        ) {
                            const itemSplit = item.split('/');
                            const allItemsAfterIdentifier = itemSplit.slice(1);
                            const rejoinedValue = allItemsAfterIdentifier.join("/");
                            selectedGridValue = gridRows.filter(
                                (x) => x[group.groupingField] === rejoinedValue
                            );
                        } else {
                            selectedGridValue = gridRows.filter(
                                (x) =>
                                    x[FieldNames.featureFields.entityType] +
                                    "-" +
                                    x[FieldNames.featureFields.entityID] ===
                                    item
                            );
                        }
                        if (selectedGridValue && selectedGridValue.length > 0) {
                            selectedItems.push(selectedGridValue[0]);
                        }
                    });

                    setAllSelectedItems(selectedItems);
                }}
                aggregationModel={aggregationModel}
                onAggregationModelChange={(newModel) => setAggregationModel(newModel)}
                getDetailPanelHeight={({row}) => "auto"} // Height based on the content.
                getDetailPanelContent={({row}) => getDetailPanelContent(row)}
                // style={{
                //   "& .MuiDataGrid-aggregationColumnHeaderLabel": {
                //     lineHeight: "0.25rem",
                //   },
                // }}
            />
          <ThemeProvider theme={theme}>
            <Snackbar
              open={snackbarOpen}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              className={classes.snackBarStyle}
              onClose={() => {
                setSnackbarOpen(false);
                setSnackbarMessage("");
              }}
            >
              <Alert
                onClose={() => {
                  setSnackbarOpen(false);
                  setSnackbarMessage("");
                }}
                severity={isFailure ? "error" : "success"}
                sx={{ width: "100%" }}
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>
          </ThemeProvider>
        </Box>
      </Paper>
    </Box>
  );
}

CarryoverManagementDialog.propTypes = {
  currentUserInfo: PropTypes.object.isRequired,
  userRoleInfo: PropTypes.array,
  setShowMap: PropTypes.func.isRequired,
};

function CarryoverGridDetailPanel({ row: rowProp }) {
  if (!rowProp) {
    return null;
  }

  return (
    <Stack
      sx={{ py: 2, height: "100%", boxSizing: "border-box" }}
      direction="column"
    >
      <Paper sx={{ flex: 1, mx: "auto", width: "90%", p: 1 }}>
        <Box
          sx={{ backgroundColor: "#D3D3D3", marginTop: "10px", width: "40%" }}
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <HelpIcon
            fontSize="small"
            color="primary"
            style={{ paddingRight: "5px" }}
          />
          <Typography fontSize={12}>
            Values listed are the most recent
          </Typography>
        </Box>
        <Stack direction="column" spacing={1} sx={{ height: 1 }}>
          <Grid container>
            <Grid item md={4}>
              {rowProp[FieldNames.carryoverFields.isCarryover] === true ? (
                <>
                  <Typography variant="h5" fontWeight={"fontWeightBold"}>
                    Carryover Target FY
                  </Typography>
                  <Typography variant="body1">
                    {rowProp[FieldNames.carryoverFields.targetFiscalYear]}
                  </Typography>
                  &nbsp;
                  <Typography variant="h5" fontWeight={"fontWeightBold"}>
                    Carryover Reason
                  </Typography>
                  <Typography variant="body1">
                    {rowProp[FieldNames.carryoverFields.reason]}
                  </Typography>
                </>
              ) : (
                <Typography>
                  Feature has not been marked as carryover
                </Typography>
              )}
            </Grid>
            <Grid item md={4}>
              {/* <Typography variant="h5" fontWeight={"fontWeightBold"}>
                Carryover Reason
              </Typography>
              <Typography variant="body1">{"Insert Reason Here"}</Typography>
              &nbsp;
              <Typography variant="h5" fontWeight={"fontWeightBold"}>
                Carryover Reason
              </Typography>
              <Typography variant="body1">{"Insert Reason Here"}</Typography> */}
            </Grid>
            <Grid item md={4}>
              {/* <Typography variant="h5" fontWeight={"fontWeightBold"}>
                Carryover Reason
              </Typography>
              <Typography variant="body1">{"Insert Reason Here"}</Typography>
              &nbsp;
              <Typography variant="h5" fontWeight={"fontWeightBold"}>
                Carryover Reason
              </Typography>
              <Typography variant="body1">{"Insert Reason Here"}</Typography> */}
              {/* <Typography variant="body1">
                {rowProp[FieldNames.userRoles.region]}
              </Typography> */}
            </Grid>
          </Grid>
        </Stack>
      </Paper>
    </Stack>
  );
}
